// extracted by mini-css-extract-plugin
export default {"actions":"notification_actions__ANnGV","userDetails":"notification_userDetails__p3YQh","ruEmail":"notification_ruEmail__xnYJ6"};